import React from "react"
import PropTypes from "prop-types"



const ScheduleNavigation = ({items}) => {
  return (
    <section className="icon1-section">
      <div className="icon1-grid fort-collis-icon-section">
        {items.map((item, index) => {
          const handleAction = () => {
            const targetElement = document.getElementById(item.scrollTo)
            if (targetElement) {
              const headerOffset = 180 // Adjust if your navbar is sticky
              const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY
              const offsetPosition = elementPosition - headerOffset

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              })
            } else {
              console.error(`Element with ID '${item.scrollTo}' not found.`)
            }
          }

          return (
            <div
              key={index}
              className="icon1-card"
              onClick={handleAction}
              role="button"
              tabIndex={0}
              style={{ cursor: "pointer" }}
            >
              <div className="icon1-wrapper">{item.icon}</div>
              <h3 className="icon1-title">{item.title}</h3>
            </div>
          )
        })}
      </div>
    </section>
  )
}

ScheduleNavigation.propTypes = {
    items: PropTypes.array
}

ScheduleNavigation.defaultProps = {
    items: []
}

export default ScheduleNavigation